<a [routerLink]="logoUrl" class="flex items-center text-2xl font-medium text-gray-900 dark:text-white">
  <img [src]="type === 'white' ? 'assets/img/logo/calia-white.svg' : 'assets/img/logo/calia.svg'" alt="Logo Calia" />
  <!-- <img src="assets/img/logo/aurodoc@3x.png" alt="Logo Aurodoc" /> -->
  <!-- <img src="assets/img/ui-commons/logo-calia.svg" alt="Logo Aurodoc" /> -->
</a>
